<template>
  <div>
    <div v-if="tipoIdPaiLocale === 7">
      <v-textarea
        v-model="nodeDataLocale.botaoOpcaoTitle"
        label="Título do botão *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required, (v) => (!!v && v.length <= 60) || 'Máximo de 60 caracteres']"
        @change="nodeConfig"
      />

      <v-divider class="mt-3 mb-3"></v-divider>

      <span class="d-flex justify-center mt-1 mb-3 font-weight-semibold text--secondary">Configurações do tipo fila</span>
    </div>

    <div v-else-if="tipoIdPaiLocale === 8">
      <v-textarea
        v-model="nodeDataLocale.listaOpcaoTitle"
        label="Título do botão *"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[validators.required, (v) => (!!v && v.length <= 24) || 'Máximo de 24 caracteres']"
        @change="nodeConfig"
      />

      <v-textarea
        v-model="nodeDataLocale.listaOpcaoDescription"
        label="Descrição do botão"
        placeholder="Digite uma Mensagem"
        outlined
        auto-grow
        rows="1"
        row-height="15"
        class="mt-2"
        :rules="[(v) => (!!v && v.length <= 72) || 'Máximo de 72 caracteres']"
        @change="nodeConfig"
      />

      <v-divider class="mt-3 mb-3"></v-divider>

      <span class="d-flex justify-center mt-1 mb-3 font-weight-semibold text--secondary">Configurações do tipo fila</span>
    </div>

    <div class="mt-2">
      <v-autocomplete
        v-model="nodeDataLocale.filaId"
        :items="filas"
        item-text="nome"
        item-value="id"
        outlined
        clearable
        label="Digite para procurar uma fila *"
        no-data-text="Nenhuma fila encontrada"
        :loading="isSearchFilaLoading"
        :rules="[validators.select]"
        :search-input.sync="searchFila"
        @change="nodeConfig"
      ></v-autocomplete>

      <v-chip
        v-if="nodeDataLocale.filaId && filaEscolhidaNome"
        color="accent"
        outlined
        class="text-truncate"
      >
        Fila escolhida: {{ filaEscolhidaNome }}
      </v-chip>
    </div>

    <div>
      <v-checkbox
        v-model="nodeDataLocale.coletarDadosClienteAntesPreenchimentoFormulario"
        label="Exigir dados pessoais?"
        @change="nodeConfig"
      />
    </div>

    <div
      v-if="nodeDataLocale.filaId"
      class="mt-3"
    >
      <v-autocomplete
        v-model="nodeDataLocale.formularioId"
        :items="formularios"
        item-text="nome"
        item-value="id"
        outlined
        clearable
        label="Digite para procurar um formulário *"
        no-data-text="Nenhum formulário encontrado"
        :loading="isSearchFormularioLoading"
        :rules="[validators.select]"
        :search-input.sync="searchFormulario"
        @change="nodeConfig"
      ></v-autocomplete>

      <v-chip
        v-if="nodeDataLocale.formularioId && formularioEscolhidoNome"
        color="accent"
        outlined
        class="text-truncate"
      >
        Formulário escolhido: {{ formularioEscolhidoNome }}
      </v-chip>
    </div>

    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-checkbox
          v-model="nodeDataLocale.atendimentoOffline"
          label="Atendimento Offline?"
          @change="nodeConfig"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row
      v-if="nodeDataLocale.possuiHorarioAtendimento"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="nodeDataLocale.horarioAtendimentoInicio"
          v-mask="'##:##:##'"
          label="Horário inicial *"
          outlined
          dense
          prefix="Horário início:"
          hide-details="auto"
          placeholder="Tempo (hh:mm:ss)"
          class="mt-2"
          validate-on-blur
          :rules="[validators.required]"
          @change="nodeConfig"
        >
        </v-text-field>
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="nodeDataLocale.horarioAtendimentoFim"
          v-mask="'##:##:##'"
          label="Horário final *"
          outlined
          prefix="Horário fim:"
          dense
          hide-details="auto"
          placeholder="Tempo (hh:mm:ss)"
          class="mt-2"
          validate-on-blur
          :rules="[validators.required]"
          @change="nodeConfig"
        >
        </v-text-field>
      </v-col>

      <v-col
        cols="12"
        sm="12"
      >
        <v-textarea
          v-if="nodeDataLocale.possuiHorarioAtendimento"
          v-model="nodeDataLocale.horarioAtendimentoMensagem"
          label="Mensagem informando horário de atendimento *"
          placeholder="Digite uma Mensagem"
          outlined
          auto-grow
          rows="1"
          row-height="15"
          class="mt-1"
          validate-on-blur
          :rules="[validators.required]"
          @change="nodeConfig"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-textarea
      v-if="nodeDataLocale.atendimentoOffline"
      v-model="nodeDataLocale.atendimentoOfflineMensagem"
      label="Mensagem Encerramento Offline *"
      placeholder="Digite uma Mensagem"
      outlined
      auto-grow
      rows="1"
      row-height="15"
      class="mt-2"
      @change="nodeConfig"
    ></v-textarea>
  </div>
</template>

<script>
import { computed, inject, onMounted, ref, watch } from '@vue/composition-api'
import { required, select } from '@/@core/utils/validation'
import NodeChatBotModel from '@/models/entities/chat-bot/NodeChatBotModel'
import FilaService from '@/services/modules/FilaService'
import FormularioService from '@/services/modules/FormularioService'

export default {
  setup(_, { emit }) {
    function nodeConfig() {
      emit('node-config')
    }

    const nodeDataLocale = ref(new NodeChatBotModel())
    const nodeData = inject('nodeData')
    watch(() => nodeData.value, value => { nodeDataLocale.value = value }, { immediate: true, deep: true })

    const tipoIdPaiLocale = ref(0)
    const tipoIdPai = inject('nodeTipoIdPai')
    watch(() => tipoIdPai.value, value => {
      tipoIdPaiLocale.value = value
    }, { immediate: true, deep: true })

    const searchFila = ref('')
    const isSearchFilaLoading = ref(false)
    const filas = ref([])

    async function handleSearchFilaChange() {
      if (!searchFila.value || isSearchFilaLoading.value) return

      try {
        isSearchFilaLoading.value = true
        filas.value = await FilaService.getFilasCanalTipoBot()
      } finally {
        isSearchFilaLoading.value = false
      }
    }
    watch(() => searchFila.value, handleSearchFilaChange)

    const searchFormulario = ref('')
    const isSearchFormularioLoading = ref(false)
    const formularios = ref([])

    async function handleSearchFormularioChange() {
      if (!searchFormulario.value || isSearchFormularioLoading.value || !nodeDataLocale.value.filaId) return

      try {
        isSearchFormularioLoading.value = true
        formularios.value = await FormularioService.getFormulariosComBot(nodeDataLocale.value.filaId)
      } finally {
        isSearchFormularioLoading.value = false
      }
    }
    watch(() => searchFormulario.value, handleSearchFormularioChange)

    const formulariosExibicao = ref([])
    const filasExibicao = ref([])

    onMounted(async () => {
      filasExibicao.value = await FilaService.getFilasCanalTipoBot()
      formulariosExibicao.value = await FormularioService.getFormulariosComBot()
    })

    const formularioEscolhidoNome = computed(() => formulariosExibicao.value.find(el => el.id === nodeDataLocale.value.formularioId)?.nome)
    const filaEscolhidaNome = computed(() => filasExibicao.value.find(el => el.id === nodeDataLocale.value.filaId)?.nome)

    return {
      nodeConfig,
      nodeDataLocale,
      tipoIdPaiLocale,
      filas,
      searchFila,
      isSearchFilaLoading,
      formularios,
      searchFormulario,
      isSearchFormularioLoading,
      formularioEscolhidoNome,
      filaEscolhidaNome,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
